var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0607 17.0607C22.6464 16.4749 22.6464 15.5251 22.0607 14.9393C21.4749 14.3536 20.5251 14.3536 19.9393 14.9393L11.9393 22.9393C11.6464 23.2322 11.5 23.6161 11.5 24C11.5 24.2034 11.5405 24.3973 11.6138 24.5742C11.687 24.7511 11.7955 24.9168 11.9393 25.0607L19.9393 33.0607C20.5251 33.6464 21.4749 33.6464 22.0607 33.0607C22.6464 32.4749 22.6464 31.5251 22.0607 30.9393L16.6213 25.5H36C36.8284 25.5 37.5 24.8284 37.5 24C37.5 23.1716 36.8284 22.5 36 22.5H16.6213L22.0607 17.0607Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_Arrow.2272a2df701f8a37f7add8aa4b48f0cc.svg";
export { ForwardRef as ReactComponent };